import React from "react";
import {UploadBase} from "./UploadBase";


const UploadDoc: React.FC = () => {

  return (
    <div>
      <UploadBase/>
    </div>
  )
}

export {UploadDoc}